import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, Alert, MenuItem } from '@mui/material';

const AddPaymentDialog = ({ open, onClose, onAdd, invoices }) => {
  const [form, setForm] = useState({
    invoice: '',
    total_amount: '',
    payment_method: '',
    payment_datetime: '',
    paid_amount: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await onAdd(form);
      setForm({ invoice: '', total_amount: '', payment_method: '', payment_datetime: '', paid_amount: '' });
    } catch (err) {
      setError(err.message || 'Failed to add payment');
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Add Payment</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error">{error}</Alert>}
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField select label="Invoice" name="invoice" value={form.invoice} onChange={handleChange} fullWidth margin="normal" required>
            {invoices.map((inv) => (
              <MenuItem key={inv.invoice_id || inv.id} value={inv.invoice_id || inv.id}>
                Invoice #{inv.invoice_id || inv.id} - {inv.total_amount}
              </MenuItem>
            ))}
          </TextField>
          <TextField label="Total Amount" name="total_amount" value={form.total_amount} onChange={handleChange} fullWidth margin="normal" required type="number" />
          <TextField label="Payment Method" name="payment_method" value={form.payment_method} onChange={handleChange} fullWidth margin="normal" required />
          <TextField label="Payment Datetime" name="payment_datetime" type="datetime-local" value={form.payment_datetime} onChange={handleChange} fullWidth margin="normal" required InputLabelProps={{ shrink: true }} />
          <TextField label="Paid Amount" name="paid_amount" value={form.paid_amount} onChange={handleChange} fullWidth margin="normal" required type="number" />
          <DialogActions>
            <Button onClick={onClose} disabled={loading}>Cancel</Button>
            <Button type="submit" variant="contained" color="primary" disabled={loading}>
              {loading ? 'Saving...' : 'Add Payment'}
            </Button>
          </DialogActions>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AddPaymentDialog; 